import { InsightsState } from './insights.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { metric, Trends } from './insights.model';
import { Time, msToMinutesSecondsWithUnit } from 'studio-components';

const getInsightsState = createFeatureSelector<InsightsState>('insights');

export const getInsights = createSelector(getInsightsState, (state) => state.insights);

export const getCallStateLoadInsights = createSelector(
  getInsightsState,
  (state) => state.callStateLoadInsights,
);

export const getInsightsError = createSelector(getInsightsState, (state) => state.apiError);

export const getMetric = createSelector(getInsightsState, (state, props: { metricKey: metric }) => {
  if (!state.insights || !state.insights[props.metricKey]) {
    return;
  }

  const { currentChart, previousChart } = state.insights[props.metricKey];
  const metricDefaults = {
    totalInteractions: [{}, { name: 'Total Interactions' }],
    avgInteractionLength: [
      { type: 'time', unit: 'minutes' },
      { name: 'Avg. Interaction Length', type: 'time', unit: 'minutes' },
    ],
    avgBitrate: [{ unit: 'kbps' }, { name: 'Avg. Bitrate', unit: 'kbps' }],
    faceDetected: [{ type: 'percentage' }, { name: 'Face Detected', type: 'percentage' }],
  };

  return {
    xAxisLabels: currentChart ? currentChart.axisData : [],
    chartData: [
      {
        seriesData: previousChart ? previousChart.seriesData : [],
        name: 'Previous Term',
        ...metricDefaults[props.metricKey][0],
      },
      {
        seriesData: currentChart ? currentChart.seriesData : [],
        name: 'Current Term',
        ...metricDefaults[props.metricKey][1],
      },
    ],
  };
});

// trends
export const getInsightsTrends = createSelector(
  getInsights,
  (insights): Trends => insights && insights.trends,
);

// percentage trend
export const getTrendPercentage = createSelector(
  getInsightsTrends,
  (trends: Trends, props): number => {
    if (!trends || !props) {
      return;
    }

    const trend = trends[props.trend];

    if (!trend.previous) {
      return;
    }

    return Math.round((trend.current * 100) / trend.previous - 100);
  },
);

// current trend
export const getCurrentTrend = createSelector(
  getInsightsTrends,
  (trends: Trends, props): string | number => {
    if (!trends || !props) {
      return;
    }

    const currentTrend = trends[props.trend].current;
    return !currentTrend ? 0 : currentTrend;
  },
);

// previous trend
export const getPreviousTrend = createSelector(
  getInsightsTrends,
  (trends: Trends, props): string | number => {
    if (!trends || !props) {
      return;
    }

    const previousTrend = trends[props.trend].previous;
    return !previousTrend ? 0 : previousTrend;
  },
);

export const getAvgInteractionLengthMinutes = createSelector(
  getInsightsTrends,
  (trends: Trends): Time =>
    trends && msToMinutesSecondsWithUnit(Number(trends.avgInteractionLength.current)),
);
